import React from "react";
import rdaLogo from "../../asset/rda-web-logo 1.png";
import { ReactSVG } from "react-svg";

const Maintanance = () => {
  return (
    <div className="bg-white w-full min-h-screen flex flex-col items-center justify-center  overflow-hidden px-4">

      {/* Circle Content */}
      <div className=" bg-[#DEE9E4]
      relative 
      p-20
        aspect-square 
        rounded-full 
        flex flex-col items-center justify-start 
        text-center 
        gap-2.5 
        ">

        {/* Logo */}
        <img
          src={rdaLogo}
          className="w-20"
          alt="RDA Logo"
        />

        {/* Heading */}
        <h1 className="text-[#00643B] font-semibold 
            2xl:text-[3.5rem] xl:text-[2.8rem] md:text-[2.5rem] text-[2rem]
          leading-tight">
          We are Under <br /> Maintenance
        </h1>

        {/* Subtitle */}
        <p className="text-[#7A7A7A] 
          text-sm sm:text-base md:text-lg lg:text-xl">
          We’re preparing to serve you better
        </p>
<div className="absolute left-0 right-0 bottom-5 w-full">
  <ReactSVG
    src="/icon/maintenance.svg"
    className="w-full h-auto"
  />
</div>
    
      </div>

     
    </div>
  );
};

export default Maintanance;